import { jsx as _jsx } from "react/jsx-runtime";
export function About() {
    return (_jsx("p", { children: "We are creating an example project to help understand how to migrate a React project to a Lit project." }));
}
